<template>
    <div class="container">
        <form @submit.prevent="register">
            <!-- <h4>عضویت</h4> -->
            
            <!-- <hr> -->

            <!-- FULL NAME -->
            <div class="form-group" :class="{'invalid': error.fullname}">
                <!-- <label for="emailFeild">نام و نام‌خانوادگی</label> -->
                <div class="row">
                    <div class="col-12 col-md-6">
                        <input 
                            v-model="firstname" type="firstname" 
                            id="firstnameFeild" class="form-control"
                            placeholder="نام"
                        >
                    </div>
                    <div class="col-12 col-md-6">
                        <input 
                            v-model="lastname" type="lastname" 
                            id="lastnameFeild" class="form-control"
                            placeholder="نام خانوادگی"
                        >
                    </div>
                </div>
                <div class="invalid-feedback">
                    پر کردن فیلد جاری اجباری می‌باشد
                </div>
            </div>

            <!-- PHONE NUMBER -->
            <div class="form-group" :class="{'invalid': error.number}">
                <label for="numberFeild">شماره موبایل</label>
                <input 
                    disabled
                    v-model="number" type="number" 
                    id="numberFeild" class="form-control"
                    placeholder="شماره موبایل خود را وارد نمایید"
                >
                <div class="invalid-feedback">
                    پر کردن فیلد جاری اجباری می‌باشد
                </div>
            </div>

            <button 
                type="submit" :disabled="loading"
                class="btn btn-success btn-center"
            >تکمیل عضویت</button>

            <!-- 
            <div class="form-footer">
                <span>عضو می‌باشید؟</span>
                <router-link  tag="span" class="span-link" :to="{ name: 'Login' }">
                    وارد شوید
                </router-link>
            </div>
             -->
        </form>
    </div>
</template>

<script>
import { postRequest } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';
const uniqid = require('uniqid');

export default {
    name: 'Register',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    data() {
        return {
            loading: false,
            firstname: undefined,
            lastname: undefined,
            number: this.$route.params.number,
            prevRoute: {},

            error: {
                fullname: false,
                number: false,
            }
        }
    },
    methods: {
        register() {            
            this.error = {
                fullname: false,
                number: false,
            }

            if (!this.firstname || !this.lastname) {
                this.error.fullname = true; 
            }
            if (!this.number) {
                this.error.number = true; 
            }
            
            if (
                (!Cookies.get('access_cookie')) && 
                !this.error.fullname && 
                !this.error.number
            ) {
                if(this.loading) return;
                else this.loading = true;

                postRequest('/users/register', {
                    id: this.$route.params.id, 
                    firstname: this.firstname,
                    lastname: this.lastname,
                    number: this.number,
                })
                    .then(() => {
                        // response
                        this.loading = false;

                        Cookies.set('access_level', 'user')
                        
                        if(this.prevRoute.name == 'PreRegister') {
                            this.$router.go(-2)
                        } else if(this.prevRoute.name) {
                            this.$router.go(-1)
                        } else {
                            this.$router.push({ name: 'Khanesh' })
                        }
                    })
                    .catch((err) => {
                        // error
                        this.loading = false;
                        if(err.response) {
                            this.$emit('alertMsg', 
                                { message: err.response.data.message, key: uniqid(), type: 'error' }
                            )
                        }
                    });
            } else if (
                (this.pass != this.cpass)
            ) {
                this.$emit('alertMsg', 
                    { message: 'شما رمز عبورتان را به درستی تکرار ننموده‌اید', key: uniqid(), type: 'error' }
                )
            }
        }
    }
}
</script>

<style src="@/assets/styles/Auth.css" scoped></style>